<template>
    <div class="email-subject">
        <a-input v-model="cloneValue" placeholder="Subject">
            <template #prefix>
                <div class="material-icons">title</div>
            </template>
        </a-input>
    </div>
</template>

<script>
import { log2 } from "../../../../../utils/log2";
const log = log2("MailSubject");
export default {
    name: "MailSubject",
    components: {},
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        cloneValue: "",
    }),
    mounted() {
        this.cloneValue = `${this.value}`;
    },
    watch: {
        cloneValue() {
            this.$emit("input", this.cloneValue);
        },
        value() {
            this.cloneValue = `${this.value}`;
        },
    },
};
</script>
<style lang="scss">
.email-subject {
    border-bottom: 1px solid var(--border-neutral-default);

    .ant-input-prefix {
        left: 6px !important;
        user-select: none;
    }

    input {
        background: #fafbfd;
        border-radius: 0 !important;
        border: none !important;
        box-shadow: none !important;
        height: 40px !important;
        padding-left: 35px !important;
    }
}
</style>
